import { useState } from 'react'
import { api } from '@/lib/api'

// CHECKPOINT: PRD-13 FR-13.9 / PRD-16 FR-16.6.1 Fetch private invoices with account authentication; provider keys stay on the server.
export function InvoiceDownload({ path }: { path: string }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const download = async () => {
    setBusy(true)
    setError('')
    try {
      if (!/^\/billing\/(payments|bulk-purchases)\/[0-9a-f-]+\/invoice$/.test(path)) throw new Error('Invalid invoice path')
      const { data } = await api.get(path, { responseType: 'blob' })
      const url = URL.createObjectURL(data)
      const link = document.createElement('a')
      link.href = url
      link.download = 'purpletoad-mail-invoice.pdf'
      document.body.appendChild(link)
      try { link.click() } finally { link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000) }
    } catch {
      setError('Could not download the invoice. Try again.')
    } finally { setBusy(false) }
  }
  return <span className="inline-flex flex-col items-start gap-1">
    <button type="button" className="underline disabled:opacity-50" disabled={busy} onClick={download}>{busy ? 'Downloading…' : 'Download invoice'}</button>
    {error && <span role="alert" className="text-xs text-destructive">{error}</span>}
  </span>
}
